const profile = {
    name: 'Nombre',
    avatar: 'Avatar',
    givenName: 'Nombre de pila',
    familyName: 'Apellido',
    middleName: 'Segundo nombre',
    fullName: 'Nombre completo',
    nickname: 'Apodo',
    preferredUsername: 'Nombre de usuario preferido',
    profile: 'Perfil',
    website: 'Sitio web',
    gender: 'Género',
    birthdate: 'Fecha de nacimiento',
    zoneinfo: 'Zona horaria',
    locale: 'Configuración regional',
    address: {
        formatted: 'Dirección',
        streetAddress: 'Dirección',
        locality: 'Ciudad',
        region: 'Estado/Provincia',
        postalCode: 'Código postal',
        country: 'País',
    },
};
export default Object.freeze(profile);
